module.exports = {
    scssVariables: './src/styles/synfun2023',
    defaultLanguage: 'en',
    profileColor: {saturation: 70, brightness: 70},
    favicon: 'sgpfavicon.ico',
    defaultPassword: 'seedcare'
}
